"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CloudDownloadIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 19l2.48-2.474a2.937 2.937 0 00-2.31-5.003v-6.24a7.003 7.003 0 018.705 4.783 4.5 4.5 0 11.77 8.934H9.002z",
    opacity: ".8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.174 15.363V6a1 1 0 012 0v9.361l1.57-1.572a.937.937 0 111.324 1.324l-2.576 2.57L6.172 19l-3.897-3.887A.936.936 0 113.6 13.788l1.574 1.575z"
  })));
});
CloudDownloadIcon.category = 'File';
var _default = CloudDownloadIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/CloudDownloadIcon.js
// module id = 1061
// module chunks = 0